import React, {useState, useEffect} from 'react';
import {Provider} from 'react-redux';
import {Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import {applyMiddleware, createStore} from 'redux';
import thunk from 'redux-thunk';
import AppReducer from '../../reducers/index';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoutes from './PrivateRoutes';
import Websocket from '../../utils/websocket/Websocket';
import cfg, {UPDATE_LANGUAGE, UPDATE_SIGNIN} from '../../constants';
import {getLanguage, getUser} from '../../actions/loginAction';
import Login from '../login/Login';
import Logout from '../login/Logout';
import Restore from '../login/Restore';
import Register from '../login/Register';
import Password from '../login/Password';
import {AlertSound} from '../../utils/alertSound/AlertSound';
import Health from '../health/Health';
import Control from '../control/Control';

const store = createStore(AppReducer, applyMiddleware(thunk));

export default function App() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!ready) {
      cfg.base_url = process.env && process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_PROD_URL : process.env.REACT_APP_LOCAL_URL;
      cfg.public_url = process.env && process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_PROD_PUBLIC_URL : process.env.REACT_APP_LOCAL_PUBLIC_URL;
      cfg.socket_url = process.env && process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_PROD_SOCKET_URL : process.env.REACT_APP_LOCAL_SOCKET_URL;
      Object.freeze(cfg);

      // get user from localStorage && set to global state
      store.dispatch({type: UPDATE_SIGNIN, profile: getUser()});
      store.dispatch({type: UPDATE_LANGUAGE, lang: getLanguage()});
      setReady(true);
    }
  }, [ready]);

  if (!ready) {
    return <div>Loading ...</div>
  }

  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/login" component={() => <Login/>}/>
          <Route path="/restore/:code" component={() => <Password/>}/>
          <Route path="/restore" component={() => <Restore/>}/>
          <Route path="/register" component={() => <Register/>}/>
          <Route path="/health-questionnaire/:code" component={() => <Health/>}/>
          <Route path="/control/:code" component={() => <Control/>}/>
          <Route path="/logout" component={Logout}/>
          <PrivateRoutes/>
        </Switch>
      </Router>
      <ToastContainer />
      <Websocket/>
      <AlertSound/>
    </Provider>
  );
}
